import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";

export function FloatingSupport() {
  const navigate = useNavigate();
  const location = useLocation();
  if (location.pathname === "/support") return null;

  return (
    <button
      data-testid="floating-support"
      onClick={() => navigate("/support")}
      aria-label="Ouvrir le centre d'aide"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#EAB308] text-black shadow-[0_0_25px_-4px_rgba(234,179,8,0.7)] hover:scale-105 transition-transform"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="absolute inset-0 rounded-full border border-[#EAB308]/60 pg-pulse-ring" />
    </button>
  );
}
